// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3EKj4","info":"Note_info__ons2S","note":"Note_note__2A-b-","actions":"Note_actions__3I0d6"};